"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdPriceAdjustDialog',
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      currentRow: null,
      form: {
        adjustType: 'none',
        adjustRatio: ''
      }
    };
  },
  methods: {
    open: function open(row) {
      this.currentRow = row;
      this.form = {
        adjustType: 'none',
        adjustRatio: ''
      };
      this.visible = true;
      this.fetchLatestAdjust(row.categoryId);
    },
    fetchLatestAdjust: function fetchLatestAdjust(categoryId) {
      var _this = this;
      jdStoreApi.getJdPriceAdjustRecords({
        categoryId: categoryId,
        page: 1,
        limit: 1
      }).then(function (res) {
        if (!_this.visible || !_this.currentRow || String(_this.currentRow.categoryId) !== String(categoryId)) return;
        var records = res && Array.isArray(res.list) ? res.list : [];
        if (!records.length || records[0].adjustRatio == null) {
          _this.form = {
            adjustType: 'none',
            adjustRatio: ''
          };
          return;
        }
        var latest = records[0];
        var ratio = parseFloat(latest.adjustRatio);
        var isRatioAdjust = latest.adjustType === 'ratio' || latest.adjustType == null && !isNaN(ratio) && ratio !== 0;
        _this.form = {
          adjustType: isRatioAdjust ? 'ratio' : 'none',
          adjustRatio: isRatioAdjust ? String(latest.adjustRatio) : ''
        };
      }).catch(function () {
        // 查询失败时保留默认值，不影响用户重新设置调价。
      });
    },
    handleRatioInput: function handleRatioInput(value) {
      var filtered = value.replace(/[^\d.\-]/g, '');
      var minusCount = (filtered.match(/-/g) || []).length;
      if (minusCount > 1 || minusCount === 1 && filtered.indexOf('-') !== 0) {
        filtered = filtered.replace(/-/g, '');
        if (filtered) filtered = '-' + filtered;
      }
      var dotIndex = filtered.indexOf('.');
      if (dotIndex !== -1) {
        var intPart = filtered.substring(0, dotIndex);
        var decPart = filtered.substring(dotIndex + 1).replace(/\./g, '').substring(0, 2);
        filtered = intPart + '.' + decPart;
      }
      if (filtered === '.' || filtered === '-.') filtered = '';
      if (filtered.length > 10) filtered = filtered.substring(0, 10);
      if (filtered && filtered !== '-') {
        var num = parseFloat(filtered);
        if (!isNaN(num)) {
          if (num > 100) filtered = '100';else if (num < -100) filtered = '-100';
        }
      }
      this.form.adjustRatio = filtered;
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.currentRow = null;
      this.form = {
        adjustType: 'none',
        adjustRatio: ''
      };
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      if (this.form.adjustType === 'ratio' && !this.form.adjustRatio.trim()) {
        this.$message.warning('请输入调价比例');
        return;
      }
      var num = parseFloat(this.form.adjustRatio);
      if (this.form.adjustType === 'ratio' && (isNaN(num) || num < -100 || num > 100)) {
        this.$message.warning('调价比例范围为 -100 ~ 100');
        return;
      }
      this.submitLoading = true;
      var adjustRatio = this.form.adjustType === 'none' ? 0 : parseFloat(this.form.adjustRatio);
      jdStoreApi.jdCategoryPriceAdjust({
        categoryId: this.currentRow.categoryId,
        categoryName: this.currentRow.groupName,
        adjustType: this.form.adjustType,
        adjustRatio: adjustRatio
      }).then(function () {
        _this2.$message.success('调价成功');
        _this2.visible = false;
        _this2.$emit('success');
      }).catch(function (e) {
        _this2.$message.error(e.message || '调价失败');
      }).finally(function () {
        _this2.submitLoading = false;
      });
    }
  }
};